import * as yup from "yup";

export const CitiesDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
  monetization: yup
    .object()
    .required()
    .test(
      "all-values-required",
      "All monetization values are required",
      function (monetization) {
        if (!monetization) return false;

        for (const key in monetization) {
          const value = monetization[key]?.value;

          if (value === undefined || value === null || value === "") {
            return this.createError({
              path: `monetization.${key}.value`,
              message: "Value is required",
            });
          }
        }
        return true;
      }
    ),
});

export const AdditionalDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});

export const ProfessionDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
  minimumHour: yup
    .number()
    .typeError("Minimum hour must be a number")
    .required("Minimum hour is required")
    .when("name", {
      is: (val) => val?.toLowerCase() === "doctor",
      then: yup.number().min(4, "Minimum hour must be at least 4 for Doctor"),
    })
    .when("name", {
      is: (val) => val?.toLowerCase() === "nurse",
      then: yup.number().min(6, "Minimum hour must be at least 6 for Nurse"),
    })
    .when("name", {
      is: (val) => !["doctor", "nurse"].includes(val?.toLowerCase()),
      then: yup.number().min(0, "Minimum hour must be at least 0"),
    }),

  maximumHour: yup
    .number()
    .typeError("Maximum hour must be a number")
    .required("Maximum hour is required")
    .max(24, "Maximum hour must be 24 or less")
    // .when("name", {
    //   is: (val) => val?.toLowerCase() === "doctor",
    //   then: yup.number().max(24, "Maximum hour must be 24 or less for Doctor"),
    // })
    // .when("name", {
    //   is: (val) => val?.toLowerCase() === "nurse",
    //   then: yup.number().max(24, "Maximum hour must be 24 or less for Nurse"),
    // })
    .moreThan(
      yup.ref("minimumHour"),
      "Maximum hour must be greater than minimum hour"
    ),
});

export const PRTDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});

export const QualificationDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[a-zA-Z\s\/\-.']*$/, "Invalid Name"),
  // .matches(/^[aA-zZ\s]+$/, "Invalid Name"), /^[a-zA-Z\s\/\-.']*$/
  profession: yup.string().required("Profession is required"),
});

export const SpecialisationDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
    profession:yup.string().required("Profession is Required")
});

export const SoftwareDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});

// Experience Type
export const ExperienceDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});

// LanguageDialog
export const LanguageDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});

// Department Type
export const DepartmentTypeDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
    profession:yup.string().required()
    
});
// Document Type
export const DocumentTypeDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
  iconLocation:yup.string().required("Icon Location is required")
});

// Company Type
export const CompanyTypeDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});

export const SkillsDialogValidation = yup.object().shape({
  name: yup
    .string()
    .required("Name is Required")
    .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
  departmentType: yup.string().required("Department Type is required")
  // .matches(/^[aA-zZ\s]+$/, "Invalid Name"),
});